import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCard({ imgPath, isBlog, title, description, ghLink, demoLink }) {
  return (
    <Card className="project-card-view">
      <Card.Img
        variant="top"
        src={imgPath}
        alt="project-img"
        style={{ height: "69%", objectFit: "cover" }}
      />
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>{description}</Card.Text>
        <div className="d-flex justify-content-between">
          {ghLink && (
            <Button variant="primary" href={ghLink} hidden={ghLink === "#"} target="_blank">   
              <BsGithub /> &nbsp;
              {isBlog ? "Blog" : "GitHub"}
             
            </Button>
          )}
          <Button
            variant="primary"
            href={demoLink}
            target="_blank"
            hidden={ demoLink === "#"}
          >
            <CgWebsite /> &nbsp;Demo
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}

export default ProjectCard;
